import React, { Component } from 'react';
import SignUpForm from '../../../widgets/account/signup';
import { Col, Container, Row } from 'reactstrap';
import Pageheading from '../../../widgets/Pageheading';

class SignUp extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div>
        {/*hero section start*/}
        <section className="position-relative">
          <Pageheading foldername={"Compte"} title={"Créer mon compte Falendi"} />
        </section>
        {/*hero section end*/}
        {/*body content start*/}
        <div className="page-content">
          {/*login start*/}
          <section className="register">
            <Container>
              <Row className="justify-content-center text-center">
                <Col className="col-lg-8 col-md-12">
                  <div className="mb-6"> <span className="badge badge-primary-soft p-2">
                    <i className="la la-exclamation ic-3x rotation" />
                  </span>
                    <h2 className="mt-3">Inscription simple et facile</h2>
                    <p className="lead">Falendi s'engage à respecter vos données.</p>
                  </div>
                </Col>
              </Row>
              <SignUpForm />
            </Container>
          </section>
          {/*login end*/}
        </div>
        {/*body content end*/}

      </div>
    );
  }
}

export default SignUp;